import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=2d2b5d87"
import script from "./info-box.vue?vue&type=script&lang=js"
export * from "./info-box.vue?vue&type=script&lang=js"
import style0 from "./info-box.vue?vue&type=style&index=0&id=2d2b5d87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports